import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import LeftImage from '../LeftImage';
import SectionHeader from '../SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getOurMission } from '../../../services/actions/MainAction';
function OurMissionSection() {
  const contentData = useSelector(state => state.Data.contentData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const ourMission = useSelector(state => state.Data.ourMission);
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getOurMission(lang_id))
  },[lang_id])

 useEffect(()=>{
      AOS.init({ duration: 1000 });
   },[])
  return (
    <section className='mt-[30px]'>
      <SectionHeader title={contentData?.section_3} />
      <div className='container'>
        <div className='grid items-start grid-cols-2  mt-[20px] max-[720px]:grid-cols-1 gap-[30px]'>
          <LeftImage url={ourMission?.image_full_url} />
          <div>
            <div className='list-permission innerTextStyle' dangerouslySetInnerHTML={{__html: ourMission?.translate?.description}}></div>
          </div>
        
        </div>
      </div>
    </section>
  )
}

export default OurMissionSection